import { onUnmounted } from 'vue';

export const useInfiniteScroll = () => {
  const lastItem = ref(null);
  const limit = ref(20);
  const observer = ref(null);
  const skip = ref(0);

  const removeIntersectionObserver = () => {
    if (observer.value) {
      observer.value.disconnect();
      observer.value = null;
    }
  };

  onUnmounted(removeIntersectionObserver);

  const handleLastItemVisible = async (entries, el, callback) => {
    let itemsReturned;

    if (entries && entries.length) {
      if (entries[0].isIntersecting) {
        if (!observer.value) {
          // Just return if the callback is triggered after the observer was removed when the
          // page is unmounted.
          return;
        }

        skip.value += limit.value;
        itemsReturned = await callback();
        observer.value.unobserve(lastItem.value);
      }
    }

    return itemsReturned;
  };

  const addIntersectionObserver = (el, callback) => {
    const selector = ':scope > li:last-child';
    lastItem.value = el.querySelector(selector);

    if (!observer.value) {
      const options = {
        rootMargin: '0px 0px 200px 0px',
        threshold: 0,
      };

      observer.value = new IntersectionObserver(
        async (entries) => {
          const itemsReturned = await handleLastItemVisible(entries, el, callback);

          if (itemsReturned) {
            addIntersectionObserver(el, callback);
          }
        },
        options,
      );
    }

    observer.value.observe(lastItem.value);
  };

  return {
    addIntersectionObserver,
    limit,
    removeIntersectionObserver,
    skip,
  };
};
